import _ from "lodash";
import { multiply, fraction, number, add, subtract, divide } from "mathjs";
import api from '@/api';

export function checkIfQuestionHasBranchingConfiguration(question) {
  if (question.branchingOptions && question.branchingOptions.length > 0) {
    for (let i = 0; i < question.branchingOptions.length; i++) {
      if (question.branchingOptions[i].hasOwnProperty("nextQuestion") && question.branchingOptions[i].nextQuestion && question.branchingOptions[i].nextQuestion.length > 0) {
        return true;
      }

      if (question.branchingOptions[i].hasOwnProperty("nextQuestionId") && question.branchingOptions[i].nextQuestionId && question.branchingOptions[i].nextQuestionId !== "") {
        return true;
      }
    }
  } else if (question.nextQuestionId && question.nextQuestionId.length > 0 && question.nextQuestionId != "default") {
    return true;
  } else if (question.recursiveLoopEndQuestionId) {
    return true;
  } else if (question.type.toLowerCase() !== "image" && question.options) {
    for (let i = 0; i < question.options.length; i++) {
      if (question.options[i].nextQuestion && question.options[i].nextQuestion.length > 0 && question.options[i].nextQuestion != "default") {
        return true;
      } else if (question.options[i].nextQuestionIdList && question.options[i].nextQuestionIdList.length) {
        //Covers MC MS Recursive branching.
        return true;
      }
    }
  } else {
    if (question.languageImageOptions && question.languageImageOptions[0] && question.languageImageOptions[0].options) {
      for (let i = 0; i < question.languageImageOptions[0].options.length; i++) {
        if (question.languageImageOptions[0].options[i].nextQuestion && question.languageImageOptions[0].options[i].nextQuestion.length > 0) {
          return true;
        }
      }
    }
  }

  return false;
}

export function checkBranchingConfiguration(question) {
  if (question.hasOwnProperty("branchingConfigured") && question.branchingConfigured == true) {
    return checkIfQuestionHasBranchingConfiguration(question);
  }
  return false;
}

function getSectionNextQuestionId(rows, index) {
  const nextQuestion = rows[index + 1].columns.length > 0 ? rows[index + 1].columns[0] : rows[index + 1];
  if (nextQuestion) {
    return nextQuestion.id;
  }
  return false;
}

function pastXMothsSuicidalIdeation(studyId) {
  switch (studyId) {
    case "9a29876b-365a-4bd3-a0d0-bdf05a5c042c":
      return 6; // DEV (For Testing of TUR-155332)
    case "5ee53d4a-dab3-4510-aca3-0f2e3cd31773":
      return 6; // STAGE (For Testing of TUR-155332)
    case "e16bb221-be6b-454e-a3b5-4f845242589a":
      return 6; // UAT (For Testing of TUR-155332)
    case "7c806f78-0b96-49c1-a392-6afe918c8412":
      return 6; // Sanofi Instance (For HS Obtain of TUR-155332)
    case "b6ef452a-9d2d-4ebc-8c3a-53246973c4b1":
      return 6; // Sanofi-UAT Instance (For Mock Study of TUR-155332)
    default:
      return "X";
  }
}
export function replacePastXMonthsString(activityData, studyId) {
  if (activityData) {
    const newResponseJSON = JSON.stringify(activityData).replaceAll("Past X Months", `Past ${pastXMothsSuicidalIdeation(studyId)} Months`); //convert to JSON string
    return JSON.parse(newResponseJSON);
  }
}
export function isBranchingConfigured(activityRows) {
  const branchingQuestions = [];

  activityRows.forEach(row => {
    if (row.columns && row.columns.length > 0) {
      row.columns.forEach(question => {
        if (checkBranchingConfiguration(question)) {
          branchingQuestions.push(question);
        }
      });
    } else {
      if (checkBranchingConfiguration(row)) {
        branchingQuestions.push(row);
      }
    }
  });

  return branchingQuestions;
}

export function isColumnDraggableConditionFulfilled(activityRows, event) {
  /** If Column is dragged to same row in different column */
  if (event.draggedContext.futureIndex != event.draggedContext.index && event.to.dataset.indexrow == event.from.dataset.indexrow) {
    return true;
  } else if (
    /** If Column is dragged to different row in same column */
    event.draggedContext.futureIndex == event.draggedContext.index &&
    event.to.dataset.indexrow != event.from.dataset.indexrow
  ) {
    const hasEmptyPlaceholder = activityRows[event.to.dataset.indexrow].columnCount > activityRows[event.to.dataset.indexrow].columns.length;
    return hasEmptyPlaceholder;
  } else if (
    /** If Column is dragged to different row in different column */
    event.draggedContext.futureIndex != event.draggedContext.index &&
    event.to.dataset.indexrow != event.from.dataset.indexrow
  ) {
    const hasEmptyPlaceholder = activityRows[event.to.dataset.indexrow].columnCount > activityRows[event.to.dataset.indexrow].columns.length;
    return hasEmptyPlaceholder;
  } else {
    return false;
  }
}

export function columnsReOrder(activityQuestions, activityRows) {
  /** Re-Numbering steps logic */
  let lastSequenceNumber = 0;
  const activityRowsArray = [];
  let prevSectionNumber = null;
  const activityQuesArray = [];
  const activityRowsObj = _.cloneDeep(activityRows);

  activityRowsObj.forEach((e, i) => {
    if (activityRowsObj[i].type !== "Section" && activityRowsObj[i].type !== "SurveyCompletion") {
      activityRowsArray[i] = [];
      let sequenceNumber = lastSequenceNumber + 1;

      /** If Question has Section */
      if (activityRowsObj[i].hasOwnProperty("section") && activityRowsObj[i].section !== null) {
        if (prevSectionNumber == null) {
          prevSectionNumber = activityRowsObj[i].section.sequence;
        }

        activityRowsObj[i].section.sequence = prevSectionNumber + 1;
        activityQuesArray.push(activityRowsObj[i].section);
      }
      /** If Question has Section */

      if (e.columns.length == 1) {
        activityRowsObj[i] = _.cloneDeep(e.columns[0]);
        activityRowsObj[i].stepSequence = sequenceNumber;
        activityRowsObj[i].sequence = sequenceNumber;
        activityRowsArray[i].push(e.columns[0].id);

        /** Update Questions */
        const activityQuesObj = _.cloneDeep(activityRowsObj[i]);
        delete activityQuesObj["columns"];
        delete activityQuesObj["columnCount"];
        //delete activityQuesObj['section'];
        activityQuesArray.push(activityQuesObj);
        /** Update Questions */
      } else if (e.columns.length > 1) {
        activityRowsObj[i].columns.map(ie => {
          ie.stepSequence = sequenceNumber;
          ie.sequence = sequenceNumber;
          sequenceNumber = sequenceNumber + 1;
          activityRowsArray[i].push(ie.id);
          /** Update Questions */
          const activityQuesObj = _.cloneDeep(ie);
          delete activityQuesObj["columns"];
          delete activityQuesObj["columnCount"];
          activityQuesArray.push(activityQuesObj);
          /** Update Questions */
          return ie;
        });
      } else {
        activityRowsObj[i] = _.cloneDeep(e);
        activityRowsObj[i].stepSequence = sequenceNumber;
        activityRowsObj[i].sequence = sequenceNumber;
        activityRowsObj[i].columnCount = activityRowsObj[i].columns.length;
        activityRowsArray[i].push(e.id);

        /** Update Questions */
        const activityQuesObj = _.cloneDeep(activityRowsObj[i]);
        delete activityQuesObj["columns"];
        delete activityQuesObj["columnCount"];
        //delete activityQuesObj['section'];
        activityQuesArray.push(activityQuesObj);
        /** Update Questions */
      }

      const currentRowColumns = activityRowsObj[i];
      lastSequenceNumber = currentRowColumns.columns.length > 0 ? currentRowColumns["columns"][currentRowColumns["columns"].length - 1].stepSequence : currentRowColumns.stepSequence;
    } else if (activityRowsObj[i].type !== "SurveyCompletion") {
      /** Update Questions */
      if (activityRowsObj[i].type == "Section") {
        const nextQuestionId = getSectionNextQuestionId(activityRowsObj, i);
        if (nextQuestionId) {
          activityRowsObj[i].nextQuestionId = nextQuestionId;
        }
      }

      const activityQuesObj = _.cloneDeep(activityRowsObj[i]);
      delete activityQuesObj["columns"];
      delete activityQuesObj["columnCount"];
      //delete activityQuesObj['section'];
      activityQuesArray.push(activityQuesObj);
      activityRowsArray.push([e.id]);
      /** Update Questions */
    } else if (activityRowsObj[i].type === "SurveyCompletion") {
      const activityQuesObj = _.cloneDeep(activityRowsObj[i]);
      activityQuesArray.push(activityQuesObj);
    }
  });

  const activityDataObj = {};
  activityDataObj["rows"] = activityRowsArray.filter(() => true);
  activityDataObj["questions"] = activityQuesArray;
  activityDataObj["activityRows"] = activityRowsObj;

  return activityDataObj;
}
export function getColumnsArrayEditMode(questionsArray, rowsArray) {
  let rowObj = [];
  const questions = _.cloneDeep(questionsArray);
  const completionQ = questions.find(o => o.type == "SurveyCompletion");
  const rows = rowsArray || [];
  const secArray = questions.filter(o => o.type == "Section");

  if (rows.length > 0) {
    rows.forEach((e, i) => {
      if (e.length > 1) {
        const thisQuestionObj = questions.find(o => o.id == e[0]);
        if (thisQuestionObj && thisQuestionObj.type !== "Section") {
          rowObj[i] = _.cloneDeep(thisQuestionObj);
          rowObj[i]["columnCount"] = e.length;
          rowObj[i]["columns"] = [];
          //rowObj[i]['section']      = null;
          if (!thisQuestionObj.hasOwnProperty("stepSequence")) {
            rowObj[i]["stepSequence"] = thisQuestionObj.sequence;
          }
          e.forEach((ie, ii) => {
            const thisQuestionObj = questions.find(o => o.id == ie);
            rowObj[i]["columns"][ii] = _.cloneDeep(thisQuestionObj);
            rowObj[i]["columns"][ii]["columnCount"] = 0;
            rowObj[i]["columns"][ii]["columns"] = [];
          });
        }
      } else if (e.length === 1) {
        const thisQuestionObj = questions.find(o => o.id == e[0]);
        if (thisQuestionObj && thisQuestionObj.type !== "Section") {
          if (!thisQuestionObj.hasOwnProperty("stepSequence")) {
            thisQuestionObj["stepSequence"] = thisQuestionObj.sequence;
          }
          rowObj[i] = _.cloneDeep(thisQuestionObj);
          rowObj[i]["columnCount"] = 0;
          rowObj[i]["columns"] = [];
          //rowObj[i]['section'] = null;
        }
      }
    });

    if (secArray.length > 0) {
      rowObj = rowObj.filter(() => true);
      secArray.forEach(section => {
        const rowIndex = rowObj.findIndex(o => o.id == section.nextQuestionId);
        if (rowIndex > -1) {
          //rowObj[rowIndex]['section'] = section;
          section["columnCount"] = 0;
          section["columns"] = [];
          rowObj.splice(rowIndex, 0, section);
        }
      });
    }
    if (completionQ) {
      rowObj.push(completionQ);
    }
    return rowObj.filter(() => true);
  } else {
    return questions
      .map(e => {
        e["columns"] = [];
        return e;
      })
      .filter(fe => {
        if (fe.type !== "SurveyCompletion") {
          return fe;
        }
      });
  }
}

export function isColumnReorderPossible(questions, rows, newVal) {
  const questionsArray = questions.filter(o => o.type !== "SurveyCompletion" && o.type !== "Section");
  if (newVal == 0 || newVal > questionsArray.length) {
    return false;
  } else if (newVal > rows[rows.length - 1].stepSequence && newVal > rows.length) {
    return false;
  } else {
    return true;
  }
}

export function reorderActivityQuestionColumn(rows, target, questionIndex, questionParentIndex) {
  let errorMessage = null;

  let selectedRowIndex = null;
  let selectedColIndex = null;

  rows.forEach((row, rowIndex) => {
    if (row.stepSequence == target && row.type != "Section") {
      selectedRowIndex = rowIndex;
    } else if (!!row.columns && row.columns.length > 0) {
      row.columns.forEach((column, colIndex) => {
        if (column.stepSequence == target) {
          if (row.columns.length <= 2) {
            selectedRowIndex = rowIndex;
            selectedColIndex = colIndex;
          } else {
            errorMessage = "You cannot move to step " + target + ", as the repective row has 3 steps already.";
          }
        }
      });
    }
  });

  if (selectedColIndex == null && errorMessage == null) {
    /** To Remove */
    const removingQuesiton = questionParentIndex == null ? Object.assign({}, rows[questionIndex]) : rows[questionParentIndex]["columns"][questionIndex];
    if (questionParentIndex == null) {
      rows.splice(questionIndex, 1);
    } else {
      rows[questionParentIndex]["columns"].splice(questionIndex, 1);
    }
    /** To Add */
    rows.splice(selectedRowIndex, 0, removingQuesiton);
  } else if (selectedRowIndex !== null && errorMessage == null) {
    /** To Remove */
    const removingQuesiton = questionParentIndex == null ? Object.assign({}, rows[questionIndex]) : rows[questionParentIndex]["columns"][questionIndex];
    if (questionParentIndex == null) {
      rows.splice(questionIndex, 1);
    } else {
      rows[questionParentIndex]["columns"].splice(questionIndex, 1);
    }

    /** To Add */
    rows[selectedRowIndex]["columns"].splice(selectedColIndex, 0, removingQuesiton);
  }

  return { rows: rows, error: errorMessage };
}

export function getActivityColumnsToQuestions(activityData) {
  if (activityData) {
    const questions = [];

    activityData.forEach(e => {
      if (e.length > 1) {
        e.forEach(ie => {
          questions.push(ie);
        });
      } else {
        questions.push(e[0]);
      }
    });

    return questions;
  } else {
    return [];
  }
}

export function getActivityColumnStructure(activityData) {
  if (activityData && activityData.customClinRO) {
    const rowObj = [];
    const mapQuestionsSequence = _.map(activityData.questions, function(question, index) {
      return _.assign(question, {
        stepSequence: index + 1
      });
    });
    const sortedQuestions = _.sortBy(mapQuestionsSequence, [
      function(o) {
        return _.toInteger(o.stepSequence);
      }
    ]);
    const allQuestions = _.cloneDeep(sortedQuestions);
    allQuestions.forEach(q => {
      rowObj.push([q]);
    });
    return rowObj;
  }
  if (activityData) {
    const rows = _.cloneDeep(activityData.rows ? activityData.rows : []);
    const allQuestions = _.cloneDeep(activityData.questions);
    const secArray = allQuestions.filter(o => o.type == "Section");
    const questions = allQuestions.filter(o => o.type != "Section");

    if (rows.length > 0) {
      const rowObj = [];
      let stepIndex = 1;
      rows.forEach((e, i) => {
        if (e.length > 1) {
          const colObj = [];
          e.forEach((ie, ii) => {
            const question = questions.find(o => o.id == ie);
            if (question !== undefined) {
              question["stepSequence"] = stepIndex;
              colObj[ii] = question;

              stepIndex++;
            }
          });
          rowObj[i] = colObj.filter(() => true);
        } else {
          const question = questions.find(o => o.id == e);
          if (question !== undefined) {
            question["stepSequence"] = stepIndex;
            rowObj[i] = [question];

            stepIndex++;
          }
        }
      });

      if (secArray.length > 0) {
        secArray.forEach(section => {
          let rowFinalIndex = null;
          rowObj.forEach((questions, index) => {
            const rowIndex = questions.findIndex(o => o.id == section.nextQuestionId);
            if (rowIndex > -1) {
              rowFinalIndex = index;
            }
          });
          rowObj.splice(rowFinalIndex, 0, [section]);
        });
        return rowObj.filter(() => true);
      } else {
        return rowObj.filter(() => true);
      }
    } else {
      const rowObj = [];
      allQuestions.forEach(q => {
        rowObj.push([q]);
      });
      return rowObj;
    }
  } else {
    return [];
  }
}

export function setRequiredFieldsOnEachStep(self) {
  if (self.formData.activity && self.formData.activity.id) {
    self.formData.activity.questions.forEach(step => {
      self.$set(step, "hasFieldError", false);
      self.$set(step, "fieldErrorText", "");
      self.$set(step, "computedScore", step.computedScore ? step.computedScore : 0);
      self.$set(step, "actualScore", step.actualScore ? step.actualScore : 0);

      // Set answer to empty if activity is new
      if (step.type === "Image" || step.type === "MultiChoice") {
        self.$set(step, "optionsIds", step.optionsIds ? step.optionsIds : []);
      } else if (step.type == "Boolean") {
        self.$set(step, "answerId", step.answerId ? step.answerId : "");
      } else if (step.type == "DateTime") {
        self.$set(step, "date", step.date ? step.date : "");
        self.$set(step, "time", step.time ? step.time : "");
      }
      self.$set(step, "answer", step.answer ? step.answer : "");
    });
  }
}

export function generateActivityAnswerFormat(question, answers, response, unansweredQuestions) {
  // Verify & assign translated question text
  const displayText = question.displayQuestionText
    ? {
        questionText: question.formattedBody,
        displayQuestionText: question.displayQuestionText
      }
    : { questionText: question.formattedBody, displayQuestionText: "" };

  switch (question.type) {
    case "Number": {
      if (question.answer) {
        const numberResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: question.answer,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: null,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(numberResponse);
      } else {
        const numberResponse = {
          questionId: question.id,
          questionName: question.type,
          answerId: null,
          answerText: "",
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };

        unansweredQuestions.push(numberResponse);
        if (question.isSkippable) {
          response.push(numberResponse);
        }
      }
      break;
    }

    case "Boolean": {
      if (question.answerId) {
        const selectedOption = question.options.find(option => option.id === question.answerId);
        const booleanResponse = {
          questionId: question.id, // string
          questionName: question.type, //string
          answerText: selectedOption ? selectedOption.body : "", //string
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: selectedOption ? selectedOption.id : "", //string
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(booleanResponse);
      } else {
        const booleanResponse = {
          questionId: question.id,
          questionName: question.type,
          answerId: null,
          answerText: "", //string
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(booleanResponse);
        if (question.isSkippable) {
          response.push(booleanResponse);
        }
      }
      break;
    }

    case "MultiChoice": {
      let isAnswerValid = false;
      if (question.optionsIds && question.optionsIds.length > 0 && question.optionsIds[0] !== null) {
        isAnswerValid = true;
      }

      if (isAnswerValid) {
        let answerText;
        if (question.optionsIds instanceof Array) {
          let selectedOptionIds = [];
          question.optionsIds.forEach(selectedOptionId => {
            if (selectedOptionId) {
              const option = question.options.find(option => (option && option.id) === selectedOptionId);

              if (option && option.id) {
                selectedOptionIds.push(option.body);
              }
            }
          });
          answerText = selectedOptionIds.join(",");
        }
        const multiChoiceResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: answerText,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          optionsIds: question.optionsIds,
          subType: question.subType,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(multiChoiceResponse);
      } else {
        const multiChoiceResponse = {
          questionId: question.id,
          questionName: question.type,
          answerId: null,
          answerText: "", //string
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : [],
          subType: question.subType
        };
        unansweredQuestions.push(multiChoiceResponse);
        if (question.isSkippable) {
          response.push(multiChoiceResponse);
        }
      }
      break;
    }

    case "Text": {
      if (question.answer) {
        const textResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: question.answer,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: null,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(textResponse);
      } else {
        const textResponse = {
          questionId: question.id,
          questionName: question.type,
          answerId: null,
          answerText: "", //string
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(textResponse);
        if (question.isSkippable) {
          response.push(textResponse);
        }
      }
      break;
    }
    case "Index": {
      if (question.answer) {
        const indexResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: question.answer,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: null,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(indexResponse);
      } else {
        const indexResponse = {
          questionId: question.id,
          questionName: question.type,
          answerId: null,
          answerText: {},
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(indexResponse);
        if (question.isSkippable) {
          response.push(indexResponse);
        }
      }
      break;
    }
    case "Measurements": {
      if (question.answer) {
        const measurementResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: question.answer,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: null,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(measurementResponse);
      } else {
        const measurementResponse = {
          questionId: question.id,
          questionName: question.type,
          answerId: null,
          answerText: "",
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(measurementResponse);
        if (question.isSkippable) {
          response.push(measurementResponse);
        }
      }
      break;
    }
    case "NumberScale": {
      if (question.answer) {
        const numberScaleResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: question.answer,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: null,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(numberScaleResponse);
      } else {
        const numberScaleResponse = {
          questionId: question.id,
          questionName: question.type,
          answerId: null,
          answerText: "",
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(numberScaleResponse);
        if (question.isSkippable) {
          response.push(numberScaleResponse);
        }
      }
      break;
    }

    case "Log": {
      if (question.multiAnswer) {
        const isAnswerAlreadySaved = find(answers, ["questionId", question.id]);
        const logResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: null,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          multiAnswer: question.multiAnswer,
          answerId: null,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        if (isAnswerAlreadySaved) {
          logResponse.answerId = isAnswerAlreadySaved.answerId;
        }
        response.push(logResponse);
      } else {
        const logResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: "",
          answerId: null,
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(logResponse);
        if (question.isSkippable) {
          response.push(logResponse);
        }
      }
      break;
    }
    case "CustomScale": {
      if (question.answer) {
        const customScaleResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: question.answer,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: null,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(customScaleResponse);
      } else {
        const customScaleResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: "",
          answerId: null,
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(customScaleResponse);
        if (question.isSkippable) {
          response.push(customScaleResponse);
        }
      }
      break;
    }

    case "ValidatedEntry": {
      if (question.answer) {
        const validatedEntryResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: question.answer,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: null,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(validatedEntryResponse);
      } else {
        const validatedEntryResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: "",
          answerId: null,
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(validatedEntryResponse);
        if (question.isSkippable) {
          response.push(validatedEntryResponse);
        }
      }
      break;
    }

    case "VAS": {
      if (question.answer) {
        const VASResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: question.answer,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: null,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(VASResponse);
      } else {
        const VASResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: "",
          answerId: null,
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(VASResponse);
        if (question.isSkippable) {
          response.push(VASResponse);
        }
      }
      break;
    }

    case "Image": {
      let isAnswerValid = false;
      if (question.optionsIds && question.optionsIds.length > 0) {
        isAnswerValid = true;
      }

      if (isAnswerValid) {
        let answerText;
        if (question.optionsIds instanceof Array) {
          let selectedOptionIds = [];
          question.optionsIds.forEach(selectedOptionId => {
            if (selectedOptionId) {
              const option = question.languageImageOptions[0].options.find(option => (option && option.id) === selectedOptionId);

              if (option && option.id) {
                selectedOptionIds.push(option.imageId);
              }
            }
          });
          answerText = selectedOptionIds.join(",");
        }

        const imageResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: answerText,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          optionsIds: question.optionsIds,
          subType: question.subType, // string
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(imageResponse);
      } else {
        const imageResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: "",
          answerId: null,
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : [],
          subType: question.subType
        };
        unansweredQuestions.push(imageResponse);
        if (question.isSkippable) {
          response.push(imageResponse);
        }
      }
      break;
    }

    case "DateTime": {
      if (question.date || question.time) {
        const dateTimeResponse = {
          questionId: question.id,
          questionName: question.type,
          answerId: null,
          date: question.showDate ? question.date : null,
          dateFormat: question.showDate ? question.dateFormat : null,
          time: question.showTime ? question.time : null,
          timeFormat: question.showTime ? question.timeFormat : null,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(dateTimeResponse);
      } else {
        const dateTimeResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: "",
          answerId: null,
          time: "",
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : [],
          date: question.showDate ? question.date : null,
          dateFormat: question.showDate ? question.dateFormat : null,
          timeFormat: question.showTime ? question.timeFormat : null
        };
        unansweredQuestions.push(dateTimeResponse);
        if (question.isSkippable) {
          response.push(dateTimeResponse);
        }
      }
      break;
    }

    case "DropDown": {
      if (question.answer) {
        const dropdownResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: question.answer,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          answerId: null,
          optionId: question.optionId,
          index: question.index,
          score: question.computedScore,
          actualScore: question.actualScore,
          isBlank: false,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        response.push(dropdownResponse);
      } else {
        const dropdownResponse = {
          questionId: question.id,
          questionName: question.type,
          answerText: "",
          optionId: "",
          index: -1,
          answerId: null,
          score: question.skipScore,
          actualScore: question.skipScore,
          questionText: displayText.questionText,
          displayQuestionText: displayText.displayQuestionText,
          isBlank: true,
          dataChecks: question.dataChecks != "undefined" ? question.dataChecks : []
        };
        unansweredQuestions.push(dropdownResponse);
        if (question.isSkippable) {
          response.push(dropdownResponse);
        }
      }
      break;
    }
  }
}

export function getDiffOfArray(oldAnswer, newAnswer) {
  if (oldAnswer.length !== newAnswer.length) {
    return true;
  }

  if (JSON.stringify(oldAnswer) === JSON.stringify(newAnswer)) {
    return false;
  } else {
    return true;
  }
}

export class Branching {
  questions = [];
  disabledFields = {};
  disabledFiledsMap = {};
  isLegacyStudy = false;
  skipToQuestion = null;
  oldValue = null;
  languageId = "ca0af64b-9a40-11e9-8a9c-12046093208c";
  questionTypes = ["SurveyInstruction", "CustomScale", "DateTime", "Date", "Time", "DropDown", "ImageCapture", "Image", "Measurements", "Log", "MedicationSelector", "MultiChoice", "Number", "Integer", "Decimal", "NumberScale", "Text", "VAS", "Boolean", "GPSkin", "Index", "ValidatedEntry", "WongBaker", "AudioRecording", "VideoRecording"];
  branchingQuestions = ["CustomScale", "Boolean", "MultiChoice", "DropDown", "Image", "NumberScale", "SurveyInstruction", "Text", "Number", "Integer"];

  constructor(isLegacyStudy, questions) {
    this.isLegacyStudy = isLegacyStudy;
    this.questions = questions;
  }

  checkLogic(question) {
    if (question.branchingConfigured && this.branchingQuestions.includes(question.type) && typeof this[`step${question.type}`] === "function") {
      if (this.disabledFields[question.id] == undefined || this.disabledFields[question.id] == false) {
        const functionName = `step${question.type}`;
        this.oldValue = null;
        this[functionName](question);
      }
    }

    return this.getDisabledFields();
  }

  clearLogic(question) {
    if (question.branchingConfigured && this.branchingQuestions.includes(question.type)) {
      // if (this.disabledFiledsMap[question.id] && this.disabledFiledsMap[question.id].length > 0){
      //     this.disabledFiledsMap[question.id].forEach((o, i) => {
      //         this.disabledFields[o] = false;
      //     });
      // }

      const functionName = `step${question.type}`;
      this.oldValue = null;
      this[functionName](question);
    }

    return this.getDisabledFields();
  }

  isAlreadyDisabled(questionId) {
    return this.disabledFields[questionId] ? this.disabledFields[questionId] : false;
  }

  isQuestionExists(questionId) {
    return !!this.questions.find(o => o.id == questionId);
  }

  getDisabledFields() {
    return this.disabledFields;
  }

  selectDisabledFields(currentQuestion, skipToQuestion, status) {
    const steps = [];
    let matchFound = false;
    if (currentQuestion && skipToQuestion && skipToQuestion !== "default" && skipToQuestion !== undefined) {
      for (let li = 0; li < this.questions.length; li++) {
        const step = this.questions[li];
        if (matchFound == true) {
          if (this.isQuestionExists(skipToQuestion)) {
            if (step.id !== skipToQuestion) {
              steps.push(step.id);
            } else {
              break;
            }
          } else if (status === false && this.disabledFiledsMap[currentQuestion]) {
            if (this.disabledFiledsMap[currentQuestion].includes(step.id)) {
              steps.push(step.id);
            } else {
              break;
            }
          } else {
            if (step.id !== skipToQuestion) {
              steps.push(step.id);
            } else {
              break;
            }
          }
        }
        if (step.id === currentQuestion) {
          matchFound = true;
        }
      }
    }
    steps.forEach(stepId => {
      this.disabledFields[stepId] = status;
    });
    if (status) {
      this.disabledFiledsMap[currentQuestion] = steps;
    }
  }

  stepCustomScale(question) {
    let selectedOption = [];
    if (question.branchingOptions && question.branchingOptions.length > 0) {
      question.branchingOptions.forEach(currentValue => {
        if (question && question.answer) {
          if (currentValue && currentValue.type == "single") {
            if (currentValue.singleValue == question.answer.replace(/<\/?[^>]+(>|$)/g, "")) {
              selectedOption.push(currentValue);
            }
          } else if (currentValue && currentValue.type == "range" && question && question.formattedLabels && question.formattedLabels.length > 0) {
            const formattedCustomScaleLabels = [];
            question.formattedLabels.forEach(element => {
              formattedCustomScaleLabels.push(element.replace(/<\/?[^>]+(>|$)/g, "")); 
            });
            const answer = formattedCustomScaleLabels.indexOf(question.answer.replace(/<\/?[^>]+(>|$)/g, ""));
            const startValue = formattedCustomScaleLabels.indexOf(currentValue.startValue);
            const endValue = formattedCustomScaleLabels.indexOf(currentValue.endValue);
            const max = Math.max(startValue, endValue);
            const min = Math.min(startValue, endValue);
            if (answer >= min && answer <= max && selectedOption.length == 0) {
              selectedOption.push(currentValue);
            }
          }
        }
        this.selectDisabledFields(question.id, currentValue.nextQuestionId, false);
      });
      if (selectedOption.length > 0) {
        selectedOption.forEach(e => {
          this.selectDisabledFields(question.id, e.nextQuestionId, true);
        });
      }
    }
  }

  stepBoolean(question) {
    if (question.options && question.options.length > 0) {
      const selectedOption = [];
      const selectedValue = question.options.find(o => o.id === question.answerId);
      if (selectedValue) {
        selectedOption.push(selectedValue);
      }
      question.options.forEach(currenValue => {
        if (question.answerId !== currenValue.nextQuestion) {
          this.selectDisabledFields(question.id, currenValue.nextQuestion, false);
        }
      });
      if (selectedOption) {
        selectedOption.forEach(e => {
          this.selectDisabledFields(question.id, e.nextQuestion, true);
        });
      }
    }
  }

  stepDropDown(question) {
    if (question.options && question.options.length > 0) {
      const selectedOption = [];
      const selectedValue = question.options.find(o => o.body === question.answer || o.formattedBody == question.answer);
      if (selectedValue) {
        selectedOption.push(selectedValue);
      }
      question.options.forEach(currenValue => {
        if (currenValue.body !== question.answer || currenValue.formattedBody !== question.answer) {
          this.selectDisabledFields(question.id, currenValue.nextQuestion, false);
        }
      });
      if (selectedOption) {
        selectedOption.forEach(e => {
          this.selectDisabledFields(question.id, e.nextQuestion, true);
        });
      }
    }
  }

  stepMultiChoice(question) {
    const optionIds = question.optionsIds.filter(o => o !== null);
    if (question.options && question.options.length > 0) {
      let selectedRule = [];
      if (question.subType == "Single") {
        const selectedValue = question.options.find(o => optionIds.includes(o.id));
        if (selectedValue) {
          selectedRule.push(selectedValue);
        }
        question.options.forEach(currentValue => {
          if (optionIds.includes(currentValue.id) == false) {
            this.selectDisabledFields(question.id, currentValue.nextQuestion, false);
          }
        });
        if (selectedRule) {
          selectedRule.forEach(e => {
            this.selectDisabledFields(question.id, e.nextQuestion, true);
          });
        }
      } else if (question.subType == "Multi") {
        if (question.branchingType === "normal" || !question.branchingType) {
          selectedRule = question.options.filter(o => optionIds.includes(o.id));
          question.options.forEach(currentValue => {
            if (optionIds.includes(currentValue.id) == false) {
              this.selectDisabledFields(question.id, currentValue.nextQuestion, false);
            }
          });
          if (selectedRule) {
            selectedRule.forEach(e => {
              this.selectDisabledFields(question.id, e.nextQuestion, true);
            });
          }
        }
        if (question.branchingType == "advance") {
          if (question.recursiveBranching === false) {
            let nextQuestionId = "";
            let selectedOption = [];
            selectedOption = question.branchingOptions.filter(option => {
              this.selectDisabledFields(question.id, option.nextQuestionId, false);
              const optionIds = option.optionIds.map(o => o.id);
              return this.arraysEqual(question.optionsIds, optionIds);
            });
            if (!!selectedOption && selectedOption.length > 0) {
              nextQuestionId = selectedOption[0].nextQuestionId;
              this.selectDisabledFields(question.id, nextQuestionId, true);
            }
          }
          if (question.recursiveBranching === true) {
            const endRecursiveLoopId = question.recursiveLoopEndQuestionId;
            let combinedNextQuestionIds = [];
            const currentQuestionSequence = this.getStepSequenceFromId(question.id);
            const selectedOptions = question.options.filter(option => {
              return question.optionsIds.includes(option.id);
            });

            question.options.map(option => {
              if (!!option && !!option.nextQuestionIdList && option.nextQuestionIdList.length > 0) {
                option.nextQuestionIdList.map(id => {
                  this.selectDisabledFields(question.id, id, false);
                });
              }
            });
            this.selectDisabledFields(question.id, endRecursiveLoopId, false);

            //Get all nextQuestion Ids for selected option in single array
            if (selectedOptions.length > 0) {
              selectedOptions.map(option => {
                if (option.nextQuestionIdList.length > 0) {
                  option.nextQuestionIdList.map(id => {
                    if (this.getStepSequenceFromId(id) > currentQuestionSequence) {
                      combinedNextQuestionIds.push(id);
                    }
                  });
                }
              });
            } else {
              combinedNextQuestionIds = [];
            }
            if (combinedNextQuestionIds.length > 0) {
              combinedNextQuestionIds.push(endRecursiveLoopId);
              combinedNextQuestionIds.sort((a, b) => (this.getStepSequenceFromId(a) > this.getStepSequenceFromId(b) ? 1 : -1));
              combinedNextQuestionIds.map((id, index) => {
                if (index == 0) {
                  this.selectDisabledFields(question.id, id, true);
                }
                if (index > 0) {
                  this.selectDisabledFields(combinedNextQuestionIds[index - 1], id, true);
                }
              });
            }
          }
        }
      }
    }
  }

  getStepSequenceFromId(id) {
    const selectedQuestion = this.questions.find(question => {
      return id === question.id;
    });
    if (selectedQuestion) {
      return selectedQuestion.stepSequence;
    }
  }

  stepImage(question) {
    const optionIds = question.optionsIds.filter(o => o !== null);
    if (question.languageImageOptions && question.languageImageOptions.length > 0) {
      let selectedOption = [];
      const questionOptions = question.languageImageOptions.find(l => l.languageId == this.languageId).options;
      if (question.subType == "Single") {
        const selectedValue = questionOptions.find(o => optionIds.includes(o.id));
        if (selectedValue) {
          selectedOption.push(selectedValue);
        }
        questionOptions.forEach(currentValue => {
          if (optionIds.includes(currentValue.id) == false) {
            this.selectDisabledFields(question.id, currentValue.nextQuestion, false);
          }
        });
      } else if (question.subType == "Multi") {
        selectedOption = questionOptions.filter(o => optionIds.includes(o.id));
        questionOptions.forEach(currentValue => {
          if (optionIds.includes(currentValue.id) == false) {
            this.selectDisabledFields(question.id, currentValue.nextQuestion, false);
          }
        });
      }
      if (selectedOption) {
        selectedOption.forEach(e => {
          this.selectDisabledFields(question.id, e.nextQuestion, true);
        });
      }
    }
  }

  stepNumberScale(question) {
    if (question.branchingOptions && question.branchingOptions.length > 0) {
      let selectedOption = [];
      question.branchingOptions.forEach(currentObj => {
        if (question && question.answer) {
          if (currentObj.type == "single") {
            if (currentObj.singleValue == question.answer) {
              selectedOption.push(currentObj);
            }
          } else if (currentObj.type == "range") {
            const max = Math.max(currentObj.startValue, currentObj.endValue);
            const min = Math.min(currentObj.startValue, currentObj.endValue);
            if (question.answer >= min && question.answer <= max) {
              selectedOption.push(currentObj);
            }
          }
        }
        this.selectDisabledFields(question.id, currentObj.nextQuestionId, false);
      });

      if (selectedOption) {
        selectedOption.forEach(e => {
          this.selectDisabledFields(question.id, e.nextQuestionId, true);
        });
      }
    }
  }

  stepSurveyInstruction(question) {
    if (question.branchingConfigured) {
      const skipToQuestion = question.nextQuestionId;
      this.selectDisabledFields(question.id, skipToQuestion, false);
      this.selectDisabledFields(question.id, skipToQuestion, true);
    }
  }
  getNextStepSquenceFromId(question, activityData) {
    let selectedRule = [];
    let nextQuestionSequence = 0;
    if (question.type === "MultiChoice") {
      const optionIds = question.optionsIds.filter(o => o !== null);
      if (question.options && question.options.length > 0) {
        if (question.subType == "Single") {
          const selectedValue = question.options.find(o => optionIds.includes(o.id));
          if (selectedValue) {
            selectedRule.push(selectedValue);
          }
        } else if (question.subType == "Multi") {
          selectedRule = question.options.filter(o => optionIds.includes(o.id));
        }
      }
    } else if (question.type === "Image") {
      const optionIds = question.optionsIds.filter(o => o !== null);
      if (question.languageImageOptions && question.languageImageOptions.length > 0) {
        const questionOptions = question.languageImageOptions.find(l => l.languageId == this.languageId).options;
        if (question.subType == "Single") {
          const selectedValue = questionOptions.find(o => optionIds.includes(o.id));
          if (selectedValue) {
            selectedRule.push(selectedValue);
          }
        } else if (question.subType == "Multi") {
          selectedRule = questionOptions.filter(o => optionIds.includes(o.id));
        }
      }
    } else if (question.type === "CustomScale") {
      if (question && question.answer) {
        const selectedValue = question.branchingOptions.find(o => o.singleValue == question.answer.replace(/<\/?[^>]+(>|$)/g, ""));
        if (selectedValue) selectedRule.push(selectedValue);
      }
    } else if (question.type === "Boolean") {
      const selectedValue = question.options.find(o => o.id === question.answerId);
      if (selectedValue) {
        selectedRule.push(selectedValue);
      }
    } else if (question.type === "DropDown") {
      const selectedValue = question.options.find(o => o.body === question.answer || o.formattedBody == question.answer);
      if (selectedValue) {
        selectedRule.push(selectedValue);
      }
    } else if (question.type === "NumberScale") {
      const selectedValue = question.branchingOptions.filter(o => (o.type == "single" ? o.singleValue == question.answer : question.answer >= o.startValue && question.answer <= o.endValue));
      if (selectedValue) {
        selectedRule.push(selectedValue);
      }
    }
    if (selectedRule && selectedRule.length > 0) {
      const updatedSelectedRule = selectedRule.filter(rule => {
        return (rule.nextQuestion ? rule.nextQuestion : rule.nextQuestionId) !== "default";
      });
      selectedRule.map(rule => {
        const nextQuestionId = rule.nextQuestion ? rule.nextQuestion : rule.nextQuestionId;
        const nextQuestion = activityData.questions.filter(step => {
          return step.id === nextQuestionId;
        });
        if (nextQuestion && nextQuestion.length > 0) {
          rule.nextQuestionSequence = nextQuestion[0].stepSequence;
        }
      });
      nextQuestionSequence = Math.max.apply(
        Math,
        updatedSelectedRule.map(rule => {
          return rule.nextQuestionSequence;
        })
      );
    }
    return nextQuestionSequence;
  }

  stepText(question) {
    if (question.branchingConfigured) {
      const skipToQuestion = question.nextQuestionId;
      if (question.answer) {
        this.selectDisabledFields(question.id, skipToQuestion, false);
        this.selectDisabledFields(question.id, skipToQuestion, true);
      } else {
        this.selectDisabledFields(question.id, skipToQuestion, false);
      }
    }
  }

  stepNumber(question) {
    if (question.branchingConfigured) {
      if (question.branchingType === "normal") {
        const skipToQuestion = question.nextQuestionId;
        if (question.answer) {
          this.selectDisabledFields(question.id, skipToQuestion, false);
          this.selectDisabledFields(question.id, skipToQuestion, true);
        } else {
          this.selectDisabledFields(question.id, skipToQuestion, false);
        }
      } else if (question.branchingType === "advance" && question.branchingOptions.length > 0) {
        const selectedOption = question.branchingOptions.find(o => Number(question.answer) >= Number(o.startValue) && Number(question.answer) <= Number(o.endValue));
        question.branchingOptions.forEach(option => {
          const startValue = Number(option.startValue);
          const endValue = Number(option.endValue);
          if (Number(question.answer) < startValue || Number(question.answer) > endValue) {
            this.selectDisabledFields(question.id, option.nextQuestionId, false);
          }
          if (!question.answer) {
            this.selectDisabledFields(question.id, option.nextQuestionId, false);
          }
        });

        if (selectedOption) {
          const skipToQuestion = selectedOption.nextQuestionId;
          if (question.answer) {
            this.selectDisabledFields(question.id, skipToQuestion, true);
          }
        }
      }
    }
  }
  arraysEqual(array1, array2) {
    if (array1 == null || array2 == null) {
      return false;
    }
    if (array1.length !== array2.length) {
      return false;
    }
    if (array1.every(item => array2.includes(item)) && array2.every(item => array1.includes(item))) {
      return true;
    }
    if (JSON.stringify(array1) === JSON.stringify(array2)) {
      return true;
    }
    return false;
  }
}

export function checkLogEntryEmptyAnswers(question) {
  let isEmptyAns = false;
  if (question.multiAnswer && question.multiAnswer.length > 0) {
    question.multiAnswer.forEach(element => {
      if (element) {
        const temp = element.filter(ans => {
          return !!ans;
        });
        if (temp.length != question.entries.length) {
          isEmptyAns = true;
        }
      }
    });
  }
  return isEmptyAns;
}

export function validateRequiredFields(question) {
  let hasError = false;
  if (
    question.hasFieldError ||
    ((question.type == "Image" || question.type == "MultiChoice") && question.optionsIds.length === 0) ||
    (question.type == "Boolean" && question.answerId == "") ||
    (question.type == "DateTime" && question.showDate && question.showTime && (question.date == "" || question.tim == "")) ||
    (question.type == "DateTime" && question.showTime && question.time == "") ||
    (question.type == "Log" && (question.multiAnswer.length == 0 || checkLogEntryEmptyAnswers(question))) ||
    ((question.type == "Text" || question.type == "Number" || question.type == "Measurements" || question.type == "ValidatedEntry" || question.type == "NumberScale" || question.type == "CustomScale" || question.type == "Index" || question.type == "DropDown" || question.type == "VAS") && (question.answer == "" || question.answer == undefined))
  ) {
    hasError = true;
  }
  return hasError;
}
       
export function getActivityVariablesList(activityRevisionId) {
    let pathParams = { activityRevisionId: activityRevisionId }
    return new Promise((resolve, reject) => {
        api.getAllVariables(pathParams)
            .then(address => {
                let filteredData = _.filter(address.body, { 'globalVisibility': 'global_site' });
                resolve(filteredData);
            }, error => {
                reject(error);
            });
    });
}

export function replaceContinuousSpacesWithTags(val){
  return val.replace(/ {2,}/g, match => {
      return "&nbsp;".repeat(match.length);
    });
}